export type ToastProps = {
  dataHook?: string;
  zIndex?: number;
  offset?: string | number;
  className?: string;
};
